<template>
  <!-- CPAP 院内在庫申請詳細 -->
  <div id="CpapEscrowRequestDetail" class="printTarget">
    <div
      :class="{ 'container-center': escrowSearchFlag }"
      v-bind:key="renderKey"
    >
      <!-- 検索画面からの表示 -->
      <template v-if="escrowSearchFlag">
        <div class="labelTitle lable printTarget">院内在庫注文詳細</div>
        <div class="button-area unPrintTarget">
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
          <b-button
            v-if="!detailEdit"
            class="backButton is-primary"
            style="right: 20px"
            icon-left="printer"
            @click="print"
            >印刷</b-button
          >
        </div>
      </template>
      <div id="item-contens">
        <div
          v-if="escrowSearchFlag"
          class="card-content margin-top printMargin printBreakInside"
        >
          <span style="font-size: 20px">医療機関情報</span>
          <table>
            <tr>
              <th>申込日</th>
              <td colspan="2">
                {{ detailObj.applicationDate }}　{{
                  detailObj.applicationUserName
                }}
              </td>
            </tr>
            <tr v-if="!(isHospital || isDealer)">
              <th>指示日<span class="require" /></th>
              <td>
                <input
                  type="date"
                  v-model="detailObj.instructionDate"
                  class="1"
                  :name="'指示日'"
                  validate="required|date"
                  style="width: 150px"
                />
              </td>
            </tr>
            <tr>
              <th>受付番号</th>
              <td colspan="2">{{ detailObj.receiptNumber }}</td>
            </tr>
            <tr>
              <th>申請元医療機関名</th>
              <td>
                {{ detailObj.medicalInstitutionName }}
              </td>
            </tr>
            <tr>
              <th>申込み状況</th>
              <td colspan="2">
                <span
                  :class="getCpapInnerStatusClass(detailObj.status)"
                  style="height: 30px; margin-left: 5px; width: 20%"
                >
                  {{ getCpapProgres(detailObj.status) }}
                </span>
              </td>
            </tr>
            <tr v-if="!(isHospital || isDealer)">
              <th>状態</th>
              <td colspan="2">
                <span
                  :class="getCpapInnerStatusClass(detailObj.status)"
                  style="height: 30px; margin-left: 5px; width: 20%"
                >
                  {{ getCpapStatus(detailObj.status) }}
                </span>
              </td>
            </tr>
          </table>
        </div>
        <!-- 内部ユーザーが注文する際の見積設定 -->
        <CpapEscrowRequestDetailEdit
          v-if="detailEdit"
          class="printTarget"
          ref="detailEdit"
          :data="detailObj"
          :quotationActive="true"
          :innerUser="true"
          :escrowSearchFlag="escrowSearchFlag"
        />
        <template v-if="!detailEdit">
          <div
            v-if="orderCompleteFlag"
            class="card-content margin-top printMargin printBreakInside"
          >
            <span style="font-size: 20px">医療機関情報</span>
            <table>
              <tr>
                <th>申込日時</th>
                <td>
                  <span
                    >{{ detailObj.applicationDate }}
                    {{ detailObj.applicationTime }}</span
                  ><span style="margin-left: 10px">{{
                    detailObj.applicationUserName
                  }}</span>
                </td>
              </tr>
              <tr>
                <th>受付番号</th>
                <td colspan="2">{{ detailObj.receiptNumber }}</td>
              </tr>
              <tr>
                <th>申請元医療機関名</th>
                <td>
                  {{ detailObj.medicalInstitutionName }}
                </td>
              </tr>
              <tr>
                <th>申込み状況</th>
                <td colspan="2">
                  <span
                    :class="getCpapInnerStatusClass(detailObj.status)"
                    style="height: 30px; margin-left: 5px; width: 20%"
                  >
                    {{ getCpapProgres(detailObj.status) }}
                  </span>
                </td>
              </tr>
              <tr v-if="!(isHospital || isDealer)">
                <th>状態</th>
                <td colspan="2">
                  <span
                    :class="getCpapInnerStatusClass(detailObj.status)"
                    style="height: 30px; margin-left: 5px; width: 20%"
                  >
                    {{ getCpapStatus(detailObj.status) }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <!-- 内部ユーザーは見積内容を表示 -->
          <template v-if="!(isHospital || isDealer)">
            <div
              v-if="orderDevice"
              class="card-content margin-top printMargin printBreakInside"
            >
              <!-- 器械内容確認 -->
              <span style="font-size: 20px">器械</span>
              <table>
                <template v-for="(item, index) in detailObj.escrowDeviceList">
                  <tr :key="index">
                    <table
                      style="
                        margin: 15px auto;
                        border-bottom: 1px solid;
                        border-bottom-color: silver;
                      "
                    >
                      <tr>
                        <th style="width: 90px">品目</th>
                        <td
                          style="width: 300px; vertical-align: middle"
                          colspan="3"
                        >
                          <span>{{
                            detailObj.escrowDeviceList[index].itemCode
                          }}</span>
                        </td>
                        <td style="width: 100px" class="tdBold">個数</td>
                        <td style="vertical-align: middle" colspan="4">
                          <span v-if="detailObj.escrowDeviceList[index]">{{
                            detailObj.escrowDeviceList[index].quantity
                          }}</span>
                        </td>
                      </tr>
                      <tr style="height: 45px">
                        <th style="width: 90px">見積番号</th>
                        <td style="width: 270px; vertical-align: middle">
                          <span>{{
                            detailObj.escrowDeviceList[index].quotationNumber
                          }}</span>
                        </td>
                        <td></td>
                        <td style="width: 110px" class="tdBold">
                          見積詳細番号
                        </td>
                        <td
                          style="width: 250px; vertical-align: middle"
                          colspan="2"
                        >
                          <span>{{
                            detailObj.escrowDeviceList[index]
                              .quotationDetailsNumber
                          }}</span>
                        </td>
                        <td style="width: 60px" class="tdBold">納入価</td>
                        <td style="width: 140px; vertical-align: middle">
                          <span
                            v-if="
                              detailObj.escrowDeviceList[index].deliveryPrice
                            "
                            >{{
                              detailObj.escrowDeviceList[index].deliveryPrice
                            }}</span
                          >
                        </td>
                        <td style="width: 60px" class="tdBold">見積日</td>
                        <td style="width: 130px; vertical-align: middle">
                          <span
                            v-if="
                              detailObj.escrowDeviceList[index]
                                .latestOrderRegisteredDate
                            "
                            >{{
                              detailObj.escrowDeviceList[index]
                                .latestOrderRegisteredDate
                            }}</span
                          >
                        </td>
                      </tr>
                    </table>
                  </tr>
                </template>
              </table>
            </div>
            <div
              v-if="orderMask"
              class="card-content margin-top printMargin printBreakInside"
            >
              <!-- マスク内容確認 -->
              <span style="font-size: 20px">マスク</span>
              <table>
                <template v-for="(item, index) in detailObj.escrowMaskList">
                  <tr :key="index">
                    <table
                      style="
                        margin: 15px auto;
                        border-bottom: 1px solid;
                        border-bottom-color: silver;
                      "
                    >
                      <tr>
                        <th style="width: 90px">品目</th>
                        <td
                          style="width: 300px; vertical-align: middle"
                          colspan="3"
                        >
                          <span>{{
                            detailObj.escrowMaskList[index].itemCode
                          }}</span>
                        </td>
                        <td style="width: 100px" class="tdBold">個数</td>
                        <td style="vertical-align: middle" colspan="4">
                          <span v-if="detailObj.escrowMaskList[index]">{{
                            detailObj.escrowMaskList[index].quantity
                          }}</span>
                        </td>
                      </tr>
                      <tr style="height: 45px">
                        <th style="width: 90px">見積番号</th>
                        <td style="width: 270px; vertical-align: middle">
                          <span>{{
                            detailObj.escrowMaskList[index].quotationNumber
                          }}</span>
                        </td>
                        <td></td>
                        <td style="width: 110px" class="tdBold">
                          見積詳細番号
                        </td>
                        <td
                          style="width: 250px; vertical-align: middle"
                          colspan="2"
                        >
                          <span>{{
                            detailObj.escrowMaskList[index]
                              .quotationDetailsNumber
                          }}</span>
                        </td>
                        <td style="width: 60px" class="tdBold">納入価</td>
                        <td style="width: 140px; vertical-align: middle">
                          <span
                            v-if="detailObj.escrowMaskList[index].deliveryPrice"
                            >{{
                              detailObj.escrowMaskList[index].deliveryPrice
                            }}</span
                          >
                        </td>
                        <td style="width: 60px" class="tdBold">見積日</td>
                        <td style="width: 130px; vertical-align: middle">
                          <span
                            v-if="
                              detailObj.escrowMaskList[index]
                                .latestOrderRegisteredDate
                            "
                            >{{
                              detailObj.escrowMaskList[index]
                                .latestOrderRegisteredDate
                            }}</span
                          >
                        </td>
                      </tr>
                    </table>
                  </tr>
                </template>
              </table>
            </div>
            <div
              v-if="orderOption"
              class="card-content margin-top printMargin printBreakInside"
            >
              <span style="font-size: 20px">用品</span>
              <table>
                <tr
                  v-for="(item, index) in detailObj.escrowOptionItemList"
                  :key="index"
                >
                  <template v-if="index == 0">
                    <th style="width: 120px">品目</th>
                  </template>
                  <template v-else>
                    <th style="width: 120px"></th>
                  </template>
                  <td style="width: 300px">
                    {{ detailObj.escrowOptionItemList[index].itemCode }}
                  </td>
                  <th style="width: 50px">個数</th>
                  <td style="width: 50px">
                    {{ detailObj.escrowOptionItemList[index].quantity }}
                  </td>
                  <th style="width: 80px">見積番号</th>
                  <td style="width: 160px">
                    {{ detailObj.escrowOptionItemList[index].quotationNumber }}
                  </td>
                  <th style="width: 100px">見積明細番号</th>
                  <td>
                    {{
                      detailObj.escrowOptionItemList[index]
                        .quotationDetailsNumber
                    }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              v-if="orderBundle"
              class="card-content margin-top printMargin printBreakInside"
            >
              <span style="font-size: 20px">同梱品</span>
              <table>
                <tr
                  v-for="(item, index) in detailObj.escrowBundleItemList"
                  :key="index"
                >
                  <template v-if="index == 0">
                    <th style="width: 120px">品目</th>
                  </template>
                  <template v-else>
                    <th style="width: 120px"></th>
                  </template>
                  <td style="width: 400px">
                    {{ detailObj.escrowBundleItemList[index].itemCode }}
                  </td>
                  <th style="width: 60px">個数</th>
                  <td style="width: 50px">
                    {{ detailObj.escrowBundleItemList[index].quantity }}
                  </td>
                  <th></th>
                  <td></td>
                  <th></th>
                  <td></td>
                </tr>
              </table>
            </div>
          </template>
          <!-- 外部ユーザーは見積内容を非表示 注文する品をまとめて表示-->
          <template v-if="isHospital || isDealer">
            <div class="card-content margin-top printMargin printBreakInside">
              <span style="font-size: 20px">注文情報</span>
              <!-- 器械テーブル -->
              <table v-if="orderDevice">
                <tr>
                  <thead>
                    <th style="width: 500px">器械</th>
                    <th style="width: 100px; text-align: center">個数</th>
                  </thead>
                </tr>
                <tr
                  v-for="(item, index) in detailObj.escrowDeviceList"
                  :key="index"
                >
                  <tbody>
                    <td style="width: 500px">
                      {{ detailObj.escrowDeviceList[index].itemCode }} :
                      {{ detailObj.escrowDeviceList[index].itemName }}
                    </td>
                    <td style="width: 100px; text-align: center">
                      {{ detailObj.escrowDeviceList[index].quantity }}
                    </td>
                  </tbody>
                </tr>
              </table>
              <!-- マスクテーブル -->
              <table v-if="orderDevice">
                <tr>
                  <thead>
                    <th style="width: 500px">マスク</th>
                    <th style="width: 100px; text-align: center">個数</th>
                  </thead>
                </tr>
                <tr
                  v-for="(item, index) in detailObj.escrowMaskList"
                  :key="index"
                >
                  <tbody>
                    <td style="width: 500px">
                      {{ detailObj.escrowMaskList[index].itemCode }} :
                      {{ detailObj.escrowMaskList[index].itemName }}
                    </td>
                    <td style="width: 100px; text-align: center">
                      {{ detailObj.escrowMaskList[index].quantity }}
                    </td>
                  </tbody>
                </tr>
              </table>
              <!-- 用品テーブル -->
              <table v-if="orderOption" style="margin-top: 20px">
                <tr>
                  <thead>
                    <th style="width: 500px">用品</th>
                    <th style="width: 100px; text-align: center">個数</th>
                  </thead>
                </tr>
                <tr
                  v-for="(item, index) in detailObj.escrowOptionItemList"
                  :key="index"
                >
                  <tbody>
                    <td style="width: 500px">
                      {{ detailObj.escrowOptionItemList[index].itemCode }} :
                      {{ detailObj.escrowOptionItemList[index].escrowItem }}
                    </td>
                    <td style="width: 100px; text-align: center">
                      {{ detailObj.escrowOptionItemList[index].quantity }}
                    </td>
                  </tbody>
                </tr>
              </table>
              <!-- 同梱品テーブル -->
              <table v-if="orderBundle" style="margin-top: 20px">
                <tr>
                  <thead>
                    <th style="width: 500px">同梱品</th>
                    <th style="width: 100px; text-align: center">個数</th>
                  </thead>
                </tr>
                <tr
                  v-for="(item, index) in detailObj.escrowBundleItemList"
                  :key="index"
                >
                  <tbody>
                    <td style="width: 500px">
                      {{ detailObj.escrowBundleItemList[index].itemCode }} :
                      {{ detailObj.escrowBundleItemList[index].itemName }}
                    </td>
                    <td style="width: 100px; text-align: center">
                      {{ detailObj.escrowBundleItemList[index].quantity }}
                    </td>
                  </tbody>
                </tr>
              </table>
            </div>
          </template>
          <div class="card-content margin-top printMargin printBreakInside">
            <span style="font-size: 20px">納品先情報</span>
            <table>
              <template v-if="!detailObj.deliveryTargetBranchOffice">
                <!-- 納品先が医療機関の場合 -->
                <tr v-if="!isHospital">
                  <th>機器納品先</th>
                  <td>医療機関</td>
                </tr>
                <tr>
                  <th>郵便番号</th>
                  <td>{{ detailObj.deliveryPostcode }}</td>
                </tr>
                <tr>
                  <th>住所</th>
                  <td>
                    {{ detailObj.deliveryAddress1 }}
                  </td>
                </tr>
                <tr>
                  <th>住所（丁目、番地）</th>
                  <td>
                    {{ detailObj.deliveryAddress2 }}
                  </td>
                </tr>
                <tr v-if="detailObj.deliveryAddress3">
                  <th>住所（建物名、号室）</th>
                  <td>
                    {{ detailObj.deliveryAddress3 }}
                  </td>
                </tr>
                <tr>
                  <th>納品先宛名</th>
                  <td>
                    {{ detailObj.receiverName }}
                  </td>
                </tr>
                <tr>
                  <th>連絡先(電話番号)</th>
                  <td>{{ detailObj.deliveryPhoneNumber }}</td>
                </tr>
              </template>
              <template v-if="detailObj.deliveryTargetBranchOffice">
                <!-- 納品先が支店の場合 -->
                <tr>
                  <th>機器納品先</th>
                  <td>支店</td>
                </tr>
                <tr>
                  <th>郵便番号</th>
                  <td>{{ detailObj.deliveryPostcode }}</td>
                </tr>
                <tr>
                  <th>住所</th>
                  <td>
                    {{ detailObj.deliveryAddress1 }}
                  </td>
                </tr>
                <tr>
                  <th>納品先宛名</th>
                  <td>
                    {{ detailObj.receiverName }}
                  </td>
                </tr>
                <tr>
                  <th>連絡先(電話番号)</th>
                  <td>{{ detailObj.deliveryPhoneNumber }}</td>
                </tr>
                <tr>
                  <th style="vertical-align: top">発送元</th>
                  <td v-if="detailObj.senderType">
                    {{
                      detailObj.senderType | codeToValueFilter(cpapSenderMaster)
                    }}
                  </td>
                </tr>
                <tr>
                  <th style="vertical-align: top">発送方法</th>
                  <td v-if="detailObj.shippingMethod">
                    {{
                      detailObj.shippingMethod
                        | codeToValueFilter(cpapShippingMethodList)
                    }}
                  </td>
                </tr>
              </template>
            </table>
          </div>
          <div
            v-if="!(isHospital || isDealer)"
            class="card-content margin-top printMargin printBreakInside"
          >
            <span style="font-size: 20px">配送情報</span>
            <table>
              <tr>
                <th>納品書コメント1</th>
                <td>
                  {{ detailObj.deliveryStatementComment1 }}
                </td>
              </tr>
              <tr>
                <th>納品書コメント2</th>
                <td>
                  {{ detailObj.deliveryStatementComment2 }}
                </td>
              </tr>
              <tr>
                <th>発送元</th>
                <td>
                  {{ detailObj.senderType }}
                </td>
              </tr>
            </table>
          </div>
          <div
            v-if="!(isHospital || isDealer)"
            class="card-content margin-top printMargin printBreakInside"
          >
            <span style="font-size: 20px">オーダー情報</span>
            <table>
              <tr>
                <th>請求開始日</th>
                <td>
                  {{ convertDate(detailObj.billingStartDate) }}
                </td>
              </tr>
              <tr>
                <th>請求書コメント</th>
                <td>
                  {{ detailObj.billComment }}
                </td>
              </tr>
              <tr>
                <th>診療科コード</th>
                <td>
                  {{ detailObj.departmentCode }}
                </td>
              </tr>
              <tr>
                <th>得意先区分</th>
                <td>
                  {{ detailObj.customerClass }}
                </td>
              </tr>
              <tr>
                <th>備考</th>
                <td>
                  {{ detailObj.memo }}
                </td>
              </tr>
            </table>
          </div>
          <div
            v-if="!(isHospital || isDealer)"
            class="card-content margin-top printMargin printBreakInside"
          >
            <span style="font-size: 20px">発送元</span>
            <table>
              <tr>
                <th>発送方法</th>
                <td>
                  {{ detailObj.shippingMethod }}
                </td>
              </tr>
              <tr>
                <th>持出元営業所</th>
                <td>
                  {{ officeCode | codeToValueFilter(branchOfficeMaster) }}
                </td>
              </tr>
              <tr>
                <th>保管場所</th>
                <td>
                  {{ detailObj.depositoryCode }}
                </td>
              </tr>
            </table>
          </div>
          <div
            v-if="!(isHospital || isDealer)"
            class="card-content margin-top printMargin printBreakInside"
          >
            <span style="font-size: 20px">配達情報</span>
            <table>
              <tr>
                <th>出荷日</th>
                <td>
                  {{ convertDate(detailObj.shippingDate) }}
                </td>
              </tr>
            </table>
          </div>
          <div
            v-if="orderCompleteFlag || escrowSearchFlag"
            class="card-content margin-top printMargin printBreakInside"
          >
            <span style="font-size: 20px">その他</span>
            <table>
              <tr>
                <th style="vertical-align: top">備考</th>
                <td style="max-width: 100%; height: 120px">
                  <span>{{ detailObj.memo }}</span>
                </td>
              </tr>
            </table>
          </div>
        </template>
        <div
          v-if="detailObj.escrowSearchFlag && detailObj.internalSearch"
          class="button-area"
        >
          <!--確定前-->
          <b-button
            class="is-primary"
            @click="cancelReasonInputModalActive = true"
            >キャンセルする</b-button
          >
          <!--確定前(中止以外)の保存-->
          <!-- <b-button v-if="mode=='edit'&&kind!='Transfer'&&kind!='Cancel'" class="is-primary" v-on:click="save">保存する</b-button> -->
          <!--中止申込みの保存-->
          <b-button class="is-primary" v-on:click="cancelSave"
            >保存する</b-button
          >
          <!-- 新規処方申込みの確定：見積もりコード設定済み -->
          <b-button class="is-primary" v-on:click="requestCpap"
            >確定する</b-button
          >
          <!-- <b-button v-if="type=='editReq' || type=='editIns'||type=='editTemp'" class="is-primary" v-on:click="requestCpap" :disabled="!targetData.estimateCode || !targetData.patientCode || (targetData.depositUseFlag && !targetData.depositUseOrderId) ">確定する</b-button> -->
          <b-button class="backButton is-primary" v-on:click="back"
            >戻る</b-button
          >
        </div>
        <div
          v-if="detailObj.escrowSearchFlag && (isHospital || isDealer)"
          class="button-area footer-selectable-contents-wrapper"
        >
          <!--確定前-->
          <b-button
            class="is-primary footer-selectable-contents"
            @click="cancelReasonInputModalActive = true"
          >
            キャンセルする
          </b-button>
          <b-button
            class="backButton is-primary positioning-back-button"
            v-on:click="back"
          >
            戻る
          </b-button>
        </div>
      </div>
    </div>
    <!-- キャンセル入力 -->
    <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
      <ReasonInputModal
        v-on:setReason="cancel"
        v-bind:title="'キャンセル理由入力'"
      ></ReasonInputModal>
    </b-modal>
    <!-- 確定前の確認 -->
    <b-modal :active.sync="escrowAfterConfirmModalActive" has-modal-card>
      <EscrowAfterConfirmModal
        :detailObj="detailObj"
        :userInfo="userInfo"
        @requestCpapAfterConfirm="requestCpapAfterConfirm"
      ></EscrowAfterConfirmModal>
    </b-modal>
  </div>
</template>
<script>
import {
  role,
  cpapSenderMaster,
  cpapShippingMethodList,
  cpapRequestStatus,
} from "@/components/mock/base/const.js";
import CpapEscrowRequestDetailEdit from "@/components/mock/common/CpapEscrowRequestDetailEdit";
import ReasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import EscrowAfterConfirmModal from "@/components/mock/philips/common/EscrowInstrumentSelectModal";

export default {
  name: "CpapEscrowRequestDetail",
  props: {
    data: null,
    innerUser: {},
    directionsItem: { default: () => [] },
    editFlg: false,
    orderCompleteFlag: false,
  },
  methods: {
    convertDate: function (day) {
      return day ? day.replace(/-/g, "/") : "";
    },
    convertMonth: function (month) {
      if (!month) return "";
      var y = month.split("-")[0];
      var m = month.split("-")[1];
      return y + "/" + m;
    },
    print: function () {
      window.print();
    },
    back: function () {
      if (this.isHospital || this.isDealer) {
        this.$router.push({
          name: "CpapEscrowRequestList",
          params: { searchConditions: this.searchParams },
        });
      } else {
        this.$router.push({
          name: "CpapEscrowRequestSearch",
          params: { searchConditions: this.searchParams },
        });
      }
    },
    Forward: async function () {
      // バリデーションチェック
      let errorMsg;
      const notInputItem = this.detailObj.escrowDeviceList.find(
        (v) => v.quotationDetailsNumber == ""
      );
      const notInputMask = this.detailObj.escrowMaskList.find(
        (v) => v.quotationDetailsNumber == ""
      );
      const notInputOption = this.detailObj.escrowOptionItemList.find(
        (v) => v.quotationDetailsNumber == ""
      );

      if (this.orderDevice && notInputItem) {
        errorMsg = "見積未選択の器械があります。\n";
      } else if (this.orderMask && notInputMask) {
        errorMsg = "見積未選択のマスクがあります。\n";
      } else if (this.orderOption && notInputOption) {
        errorMsg = "見積未選択の用品があります。\n";
      }

      if (errorMsg) {
        this.showErrorMessage(errorMsg);
      } else {
        this.$router.push({
          name: "CpapEscrowRequestDetail",
          params: { detailObj: this.detailObj, salesEdit: true },
        });
      }
    },
    requestCpap: function () {
      this.escrowAfterConfirmModalActive = true;
      // TODO:モーダルから注文処理を実行する処理が必要
      // var messsage =
      //   "院内在庫を注文します。<br/>機種が正しいことを確認して「OK」ボタンを押してください。";
      // this.$dialog.confirm({
      //   title: "申込み確認",
      //   message: messsage,
      //   cancelText: "修正する",
      //   onConfirm: async () => {
      //     this.compleateFlg = false;
      //     var excuteApi = this.setCpapEscrowRequestPOST;
      //     var successCallBack = this.setCpapEscrowRequestPOSTSuccess;
      //     var errorCallBack = this.setCpapEscrowRequestPOSTError;
      //     // WebAPI Call
      //     await this.apiCall(excuteApi, successCallBack, errorCallBack);
      //     if (this.compleateFlg) {
      //       this.jumpToTop();
      //       this.activeStep += 1;
      //     }
      //   },
      // });
    },
    requestCpapAfterConfirm: function (modalObj) {
      this.compleateFlg = false;
      // TODO:営業の支店回覧の登録の場合、受付番号を再取得して二重に登録してしまう(元の注文も残ったまま)
      this.detailObj.reqParams = JSON.parse(JSON.stringify(modalObj));
      this.detailObj.reqParams.salesRegistrationFlag = true;
      this.userInfo = modalObj.userInfo;
      const excuteApi = this.setCpapEscrowRequestPOST;
      const successCallBack = this.setCpapEscrowRequestPOSTSuccess;
      const errorCallBack = this.setCpapEscrowRequestPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
      if (this.compleateFlg) {
        this.jumpToTop();
      }
    },
    setCpapEscrowRequestPOST: function (client) {
      let obj = JSON.parse(JSON.stringify(this.detailObj.reqParams));

      // 医療機関コード
      obj.medicalInstitutionCode = this.userInfo.medicalInstitutionCode;

      // 納品先
      obj.delivaryTarget = "hospital";

      // ユーザー情報
      obj.userInfo = this.userInfo;

      // 外部ユーザーの場合
      if (this.isHospital || this.isDealer) {
        obj.status = this.cpapRequestStatus.request; //　ステータス 指示書申請中：1
        obj.status = this.cpapRequestStatus.request; //　ステータス 指示書申請中：1
      } else {
        // 内部ユーザーの場合
        obj.status = this.cpapRequestStatus.preparingEquipment; // ステータス 機器準備中 : 5
      }

      return client.apis.externalCpap.setCpapEscrowRequestPOST({
        body: obj,
      });
    },
    setCpapEscrowRequestPOSTSuccess: function (result) {
      // 成功メッセージ表示
      this.detailObj.reqParams.applicationDate = result.obj.requestDate;
      this.detailObj.reqParams.applicationTime = result.obj.requestTime;
      this.detailObj.reqParams.applicationUserName = result.obj.requestUserName;
      this.detailObj.reqParams.receiptNumber = result.obj.receiptNumber;
      // 再レンダリングの為、フラグ切替
      this.renderKey = !this.renderKey;
      this.compleateFlg = true;

      // 検索からの登録の場合、登録完了画面表示 （2023.10.17時点、このまま遷移しても何の情報もないためエラーになります。丸山）
      if (result.obj.salesRegistrationFlag) {
        this.$router.push({
          name: "CpapEscrowRequestDetail",
          params: { orderCompleteFlag: true },
        });
      }
    },
    setCpapEscrowRequestPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    requestSave: async function () {
      const excuteApi = this.setCpapEscrowRequestSavePOST;
      const successCallBack = this.setCpapEscrowRequestSavePOSTSuccess;
      const errorCallBack = this.setCpapEscrowRequestSavePOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setCpapEscrowRequestSavePOST: function (client) {
      let obj = JSON.parse(JSON.stringify(this.targetData));
      obj.detailObj = this.detailObj;

      return client.apis.internalCpap.setCpapEscrowRequestSavePOST({
        body: obj,
      });
    },
    setCpapEscrowRequestSavePOSTSuccess: function (result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.back();
    },
    setCpapEscrowRequestSavePOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    cancel: function (cancelReason) {
      // 申請取下げ
      this.reason = cancelReason;
      const excuteApi = this.setCpapEscrowRequestWithdrawPOST;
      const successCallBack = this.setCpapEscrowRequestWithdrawPOSTSuccess;
      const errorCallBack = this.setCpapEscrowRequestWithdrawPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setCpapEscrowRequestWithdrawPOST: function (client) {
      let obj = JSON.parse(JSON.stringify(this.targetData));
      obj.reason = this.reason;
      obj.detailObj = this.detailObj;
      return client.apis.externalCpap.setCpapEscrowRequestWithdrawPOST({
        body: obj,
      });
    },
    setCpapEscrowRequestWithdrawPOSTSuccess: function (result) {
      this.showSuccess(result);
      this.back();
    },
    setCpapEscrowRequestWithdrawPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
  },
  data() {
    const targetNumber = this.$route.params["receiptNumber"];
    const targetKind = this.$route.params["kind"];
    const targetStatus = this.$route.params["status"];
    const searchParams = this.$route.params["searchConditions"];
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const roleId = userInfo.roleId;
    const userId = userInfo.id;
    const isDealer = roleId == role.role_dealer;
    const isHospital = roleId == role.role_hospital;
    const officeCode = userInfo.salesOfficeCode;
    const branchOfficeMaster = this.getSalesOfficeMaster();
    let detailEdit = "";
    return {
      targetNumber,
      searchParams,
      targetData: {},
      roleId,
      userId,
      userInfo,
      isHospital,
      isDealer,
      role,
      kind: targetKind,
      status: targetStatus,
      cancelReasonInputModalActive: false,
      reason: "",
      renderKey: false,
      cpapSenderMaster,
      detailObj: "",
      orderDevice: false,
      orderMask: false,
      orderOption: false,
      orderBundle: false,
      escrowSearchFlag: false,
      cpapShippingMethodList,
      internalUser: false,
      cpapRequestStatus,
      salesEdit: false,
      officeCode,
      branchOfficeMaster,
      escrowAfterConfirmModalActive: false,
      detailEdit,
    };
  },
  filters: {
    codeToValueFilter: function (val, list) {
      var target = list.find((item) => item.code + "" == val + "");
      if (target) {
        return target.name;
      }
      return "";
    },
  },
  components: {
    CpapEscrowRequestDetailEdit,
    ReasonInputModal,
    EscrowAfterConfirmModal,
  },
  async mounted() {
    if (this.data) {
      // 院内在庫注文からの遷移
      this.detailObj = this.data;
    } else if (this.$route.params.escrowSearchFlag) {
      // 注文履歴検索からの遷移
      this.detailObj = JSON.parse(JSON.stringify(this.$route.params));
      this.escrowSearchFlag = true;
      if (
        this.$route.params.internalSearch &&
        this.$route.params.status == this.cpapRequestStatus.request
      ) {
        // 内部ユーザーの検索かつステータスが指示書申請中の場合、編集
        this.detailEdit = true;
      }
    } else if (this.$route.params.salesEdit) {
      // 履歴検索から、営業による編集後の遷移
      this.detailObj = this.$route.detailObj;
      this.salesEdit = true;
    }

    // 表示判断
    if (
      this.detailObj.escrowDeviceList.length > 0 &&
      this.detailObj.escrowDeviceList[0].itemCode
    ) {
      this.orderDevice = true;
    }
    if (
      this.detailObj.escrowMaskList.length > 0 &&
      this.detailObj.escrowMaskList[0].itemCode
    ) {
      this.orderMask = true;
    }
    if (
      this.detailObj.escrowOptionItemList.length > 0 &&
      this.detailObj.escrowOptionItemList[0].itemCode
    ) {
      this.orderOption = true;
    }
    if (
      this.detailObj.escrowBundleItemList.length > 0 &&
      this.detailObj.escrowBundleItemList[0].itemCode
    ) {
      this.orderBundle = true;
    }

    if (this.editFlg) {
      this.detailEdit = this.editFlg;
    }

    if (this.$route.params.internalUser) {
      this.internalUser = true;
    }
  },
};
</script>

<style lang="scss" scoped>
#item-contens table.settings tr th {
  width: 300px;
}
.container-center {
  width: 1200px;
  padding: 14px;
  margin: auto;
}
.footer-selectable-contents-wrapper {
  display: flex;
  justify-content: center;
  position: relative;
}
.footer-selectable-contents {
  margin: 0 2px;
}
.positioning-back-button {
  position: absolute;
  right: 0;
}
.tdBold {
  vertical-align: middle;
  font-weight: bold;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/common/CpapEscrowRequestDetail.vue